export const profileTheme = {
  borderColor: '--medkit-profile-border-color',
  headingSize: '--medkit-profile-heading-size',
  headingColor: '--medkit-profile-heading-color',
  headingSubtitleColor: '--medkit-profile-heading-subtitle-color',
  headingSubtitleSize: '--medkit-profile-heading-subtitle-size',
  primary: '--medkit-profile-primary',
}
